import React from "react"
import "./horizontal-line.scss"

export default function HorizontalLine({ classname }) {
  return (
    <div className={`line ${classname}`}/>
  )
}
